// extracted by mini-css-extract-plugin
export default {"dropdown":"emp_src-components-common-Dropdown-index__dropdown--PZWYR"};